
/// <amd-module name="Wit/BoardsHub/KanbanBoard/SignalR/Contracts" />
export interface IBoardUpdatePayload {
    id: number;
    changeType: string;
    revision: number;
    stackRank: string;
    changedChildren: boolean;
    changedTypeOrTitle: boolean;
}

export type BoardWorkItemsUpdatedCallback = (updates: IBoardUpdatePayload[]) => void;

export type BoardSettingsUpdatedCallback = () => void;
